export const TABLE_V2_SELECT_ALL_KEY = '_ALL';
